// REACT IMPORTS
import React, { Component, useRef, useState } from "react";
import { useNavigate, useSearchParams } from 'react-router-dom';
import ReCAPTCHA from "react-google-recaptcha"
import Cookies from 'universal-cookie';

const cookies = new Cookies();
// MDBOOTSTRAP IMPORTS
import { 
  MDBRow, 
  MDBCol, 
  MDBIcon,
  MDBInputGroup,
  MDBCheckbox
} from 'mdb-react-ui-kit';




// STYLE IMPORTS
import "react-toggle/style.css";

import paypal from '../../assets/media/logo/paypal.png'


class ProfileForm extends Component {
 
  constructor(props) {
    super(props);
      this.state = {email: "",
                    firstName: "",
                    lastName: "",
                    password: "",
                    confirmPassword: "",
                    fullName: "",
                    address: "",
                    postalCode: "",
                    city: "",
                    country: "",     
      };
  };
/*
  componentDidMount(){
    document.getElementById("controlledCheckbox_1").setCustomValidity("Kérjük fogadd el a nyilatkozatot, kattints a körbe!");
    document.getElementById("controlledCheckbox_2").setCustomValidity("Kérjük fogadd el a nyilatkozatot, kattints a körbe!");
  }
*/
    onCustomer = (e) => {
      e.preventDefault();
      let self = this;
      var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      const token = this.props.captchaRef.current.getValue();

      if(this.state.password === this.state.confirmPassword){
        if(this.state.email.match(validRegex)){
          this.props.context.interAxios.post('/auth/register',
          {
            email: this.state.email,
            password: this.state.password,
            lastName: this.state.lastName,
            firstName: this.state.firstName,
            captchaToken: token,
            directMarketingConsent: this.props.checkedMarketing,
            billing: {
              name: this.state.fullName,
              postcode: this.state.postalCode,
              country: this.state.country,
              region: "",
              location: this.state.city,
              address: this.state.address,
              vatCode: ""
            },
            paymentService: "SIMPLEPAY"
            }, function(response) {
              self.props.context.closeLoginModal()
              self.props.context.openLoginModal("succesRegistration");
          
                 
            }, function (error) {
              alert('Registration failed! Check the given data!')
          });
     
        }else {
          alert('Email format is incorrect!')
        }
      }else {
        alert('Check the entered passwords!')
      }
      
    }

    changeHandler = event => {
      this.setState({ [event.target.name]: event.target.value });
    };
  
  render() {
    
    return (<>
              <form onSubmit={(e) => this.onCustomer(e)} className="profile-form" autoComplete="off">
                <div className="white-panel">
                  {/** FIRST NAME **/}
                  <MDBRow className="pb-2 m-0">
                    <MDBCol md='6'>
                      <label htmlFor="firstName">First name*</label>
                      <input
                        id='firstName'
                        name='firstName'
                        type='text'
                        onChange={this.changeHandler}
                        value={this.state.firstName}
                        onKeyDown={(e) => {
                          if (e.key == 'Tab') {
                            e.preventDefault();
                            e.stopPropagation();
                            this.props.firstnameRef.current.focus()
                          }
                        }}
                        required
                      />
                    </MDBCol>
                    <MDBCol md='6'>
                      <label htmlFor="lastName">Last name*</label>
                      <input
                        id='lastName'
                        name='lastName'
                        type='text'
                        onChange={this.changeHandler}
                        value={this.state.lastName}
                        ref={this.props.firstnameRef}
                        onKeyDown={(e) => {
                          if (e.key == 'Tab') {
                            e.preventDefault();
                            e.stopPropagation();
                            this.props.emailRef.current.focus()
                          }
                        }}
                        required
                      />
                    </MDBCol>
                  </MDBRow>

                
                  {/** EMAIL **/}
                  <MDBRow className="pb-2 m-0">
                    <MDBCol md='6'>
                      <label htmlFor="email">E-mail address*</label>
                      <input
                        id='email'
                        name='email'
                        type='text'
                        onChange={this.changeHandler}
                        value={this.state.email}
                        ref={this.props.emailRef}
                        onKeyDown={(e) => {
                          if (e.key == 'Tab') {
                            e.preventDefault();
                            e.stopPropagation();
                            this.props.passwordfirstRef.current.focus()
                          }
                        }}
                        required
                      />
                    </MDBCol>
                  </MDBRow>


                  {/** PASSWORDs **/}
                  <MDBRow className="pb-2 m-0">
                    <MDBCol md='6'>
                      <label htmlFor="password">Password*</label>
                      <MDBInputGroup
                        className="jc-password"
                        noWrap 
                        textAfter={(
                          <MDBIcon 
                            className={"fa-regular" + (this.props.hidePassword ? ' fa-eye' : ' fa-eye-slash')}
                            onClick={() => this.props.setHidePassword(!this.props.hidePassword)}
                          ></MDBIcon>
                        )}
                      >
                        <input 
                          type={this.props.hidePassword ? 'password' : 'text'} 
                          value={this.state.password}
                          onChange={this.changeHandler}
                          ref={this.props.passwordfirstRef}
                          id='password'
                          name='password'
                          onKeyDown={(e) => {
                            if (e.key == 'Tab') {
                              e.preventDefault();
                              e.stopPropagation();
                              this.props.passwordtwoRef.current.focus()
                            }
                          }}
                          required
                        />
                      </MDBInputGroup>
                    </MDBCol>
                    <MDBCol md='6'>
                      <label htmlFor="confirmPassword">Re-enter password*</label>
                      <MDBInputGroup
                        className="jc-password"
                        noWrap 
                        textAfter={(
                          <MDBIcon 
                            className={"fa-regular" + (this.props.hidePasswordtwo ? ' fa-eye' : ' fa-eye-slash')}
                            onClick={() => this.props.setHidePasswordtwo(!this.props.hidePasswordtwo)}
                          ></MDBIcon>
                        )}
                      >
                        <input 
                          type={this.props.hidePasswordtwo ? 'password' : 'text'} 
                          value={this.state.confirmPassword}
                          onChange={this.changeHandler}
                          ref={this.props.passwordtwoRef}
                          id='confirmPassword'
                          name='confirmPassword'
                          onKeyDown={(e) => {
                            if (e.key == 'Tab') {
                              e.preventDefault();
                              e.stopPropagation();
                              this.props.nameRef.current.focus()
                            }
                          }}
                          required
                        />
                      </MDBInputGroup>
                    </MDBCol>
                  </MDBRow>

                  <MDBRow className="py-2 m-0">
                    <MDBCol md='12' className="p-0">
                      <MDBRow className="pb-2 m-0">
                        <MDBCol md='12' size="12">
                          <span className="modal-title-form">Billing date</span>
                        </MDBCol>
                      </MDBRow>
                      <MDBRow className="py-2 m-0">
                        <MDBCol md='6'>
                          <label htmlFor="address">Public name</label>
                          <input
                            id='fullName'
                            name='fullName'
                            type='text'
                            onChange={this.changeHandler}
                            value={this.state.fullName}
                            ref={this.props.nameRef}
                            onKeyDown={(e) => {
                              if (e.key == 'Tab') {
                                e.preventDefault();
                                e.stopPropagation();
                                this.props.addressRef.current.focus()
                              }
                            }}
                            required
                          />
                        </MDBCol>
                     
                        <MDBCol md='6' size="12">
                          <label htmlFor="address">Address*</label>
                          <input
                            id='address'
                            name='address'
                            type='text'
                            onChange={this.changeHandler}
                            value={this.state.address}
                            ref={this.props.addressRef}
                            onKeyDown={(e) => {
                              if (e.key == 'Tab') {
                                e.preventDefault();
                                e.stopPropagation();
                                this.props.postcodeRef.current.focus()
                              }
                            }}
                            required
                          />
                        </MDBCol>
                      </MDBRow>
                      <MDBRow className="pb-5 m-0">
                        <MDBCol md='2' size="12">
                        <label htmlFor="postalCode">Postal code*</label>
                          <input
                            id='postalCode'
                            name='postalCode'
                            type='text'
                            onChange={this.changeHandler}
                            value={this.state.postalCode}
                            ref={this.props.postcodeRef}
                            onKeyDown={(e) => {
                              if (e.key == 'Tab') {
                                e.preventDefault();
                                e.stopPropagation();
                                this.props.cityRef.current.focus()
                              }
                            }}
                            required
                          />
                        </MDBCol>
                        <MDBCol md='5'>
                        <label htmlFor="city">City*</label>
                          <input
                            id='city'
                            name='city'
                            type='text'
                            onChange={this.changeHandler}
                            value={this.state.city}
                            ref={this.props.cityRef}
                            onKeyDown={(e) => {
                              if (e.key == 'Tab') {
                                e.preventDefault();
                                e.stopPropagation();
                                this.props.countryRef.current.focus()
                              }
                            }}
                            required
                          /> 
                        </MDBCol>
                        <MDBCol md='5' size="12">
                        <label htmlFor="postalCode">Country*</label>
                          <input
                            id='country'
                            name='country'
                            type='text'
                            onChange={this.changeHandler}
                            value={this.state.country}
                            ref={this.props.countryRef}
                            required
                          />
                        </MDBCol>
                      </MDBRow>
                    </MDBCol>
                  </MDBRow>

                {/* <MDBRow className="py-2 m-0">
                    <MDBCol md='12' className="p-0">
                      <MDBRow className="pb-2 m-0">
                        <MDBCol md='12'  className="d-grid align-items-center justify-content-start ">
                          <div className="checkbox-div d-flex align-items-start pb-4">
                            <MDBCheckbox
                              id='controlledCheckbox_1'
                              label=""
                              checked={this.props.checked}
                              setCustomValidity="message"

                              onChange={() => this.props.setChecked(!this.props.checked)}
                              required
                            /> 
                            <div>
                            Kijelentem, hogy az Alakreform Kft.  <a href={aszf} target="_blank">általános szerződési feltételeket </a>feltételeket teljes körűen megismertem és 
                            elfogadom, az abban foglalt rendelkezéseket magamra nézve kötelezőnek ismerem el.
                            </div>
                            
                          </div>   
                          <div className="checkbox-div d-flex align-items-start pb-4">
                            <MDBCheckbox
                              id='controlledCheckbox_2'
                              label=""
                              checked={this.props.checked_2}
                              onChange={() => this.props.setChecked_2(!this.props.checked_2)}
                              required
                            /> 
                            <div>
                            Kijelentem, hogy az <a href={privacy} target="_blank">adatkezelési tájékoztatójának </a>tartalmát teljes körűen megismertem és az adatkezelési 
                            tájékoztató tartalmát tudomásul vettem, továbbá hozzájárulok ahhoz, hogy a személyes adataimat az adatkezelési tájékoztatóban meghatározottak szerinti céllal és feltételekkel kezelje az Alakreform Kft. 
                            </div>
                            
                          </div>   
                          <div className="checkbox-div d-flex align-items-start pb-4">
                            <MDBCheckbox
                              id='controlledCheckbox_3'
                              label=""
                              checked={this.props.checkedMarketing}
                              onChange={() => this.props.setCheckedMarketing(!this.props.checkedMarketing)}
                            /> 
                            <div>
                            Önkéntesen hozzájárulok, hogy e-mail címemet az Alakreform Kft. visszavonásig direkt marketing célra, hírlevél küldése érdekében kezelje az 
                            általam megismert adatkezelési tájékoztatónak megfelelően, és részemre ajánlatokat küldjön, aktuális ajánlatairól tájékoztasson. A hozzájárulás a jövőre nézve bármikor visszavonható a   
                            <a href={"mailto:rendezveny@rubintreka.hu"} target="_blank"> rendezveny@rubintreka.hu </a>e-mail cím alatt.
                            </div>
                            
                          </div>     
                        </MDBCol>
                      </MDBRow>
                    </MDBCol>
                 
                          </MDBRow>*/}

                
        {/*     <MDBRow center className="pt-4 m-0">
                    <MDBCol md='6' className="p-0">
                      <div className="checkbox-div d-flex align-items-center justify-content-center pb-4">
                        <MDBCheckbox
                            id='controlledCheckbox_3'
                            label=""
                            checked={this.props.isSimplepay}
                            onChange={() => {this.props.setIsPaypal(false); this.props.setIsSimplepay(!this.props.isSimplepay)}}
                          /> 
                      
                        <a href="http://simplepartner.hu/PaymentService/Fizetesi_tajekoztato.pdf" target="-blank"><img src={splogo} height='40' style={{marginLeft: "15px"}}/></a>
                      </div>
                    </MDBCol>
                    <MDBCol md='6' className="p-0">
                      <div className="checkbox-div d-flex align-items-center justify-content-center pb-4">
                        <MDBCheckbox
                          id='controlledCheckbox_3'
                          label=""
                          checked={this.props.isPaypal}
                          onChange={() => {this.props.setIsSimplepay(false); this.props.setIsPaypal(!this.props.isPaypal)}}
                        /> 
                        <img src={paypal} height='30' style={{marginLeft: "15px"}}/>
                      </div>
                    </MDBCol>
                        </MDBRow>
                 */}
                  <MDBRow className="py-2 m-0">
                    <MDBCol md='12' className="p-0 d-flex justify-content-center align-items-center ">
                      <ReCAPTCHA
                        ref={this.props.captchaRef}
                        sitekey={"6LdU-FAoAAAAALMMm9vjM3lQQJiLLQN5duzkGyP8"}
                      />
                    </MDBCol>
                  </MDBRow>
                  {/*!this.props.isPaypal && !this.props.isSimplepay ? 
                  <MDBRow center className="pb-3 m-0">
                    <MDBCol md='12' className="p-0">
                          <div className="d-flex justify-content-center align-items-center pt-3">
                            <button type="button" onClick={() => alert("Válassz ki egy fizetési módot!")} className="rergistration-button modal-button black-pay ">
                              <span>JOIN US</span>
                            </button>
                          </div>
                    </MDBCol>
                    
                  </MDBRow>:
                  <MDBRow center className="pb-3 m-0">
                  <MDBCol md='12' className="p-0">
                        <div className="d-flex justify-content-center align-items-center pt-3">
                          <button type="submit" className="rergistration-button modal-button green" ref={this.props.buttonRef}>
                            <span>JOIN US</span>
                          </button>
                        </div>
                  </MDBCol>
                  
                        </MDBRow>*/}
                 
                 <MDBRow center className="pb-3 m-0">
                    <MDBCol md='12' className="p-0">
                          <div className="d-flex justify-content-center align-items-center pt-3">
                            <button type="submit" className="rergistration-button modal-button green" ref={this.props.buttonRef}>
                              <span>JOIN US</span>
                            </button>
                          </div>
                    </MDBCol>
                  
                  </MDBRow>
                  </div>
              </form>

               
      </>
    );
  }
};

function ProfileFormFunc(props) {
  let [searchParams] = useSearchParams();
  const [hidePassword, setHidePassword] = useState(true);
  const [hidePasswordtwo, setHidePasswordtwo] = useState(true);
  const [checked, setChecked] = useState(false);
  const [isPaypal, setIsPaypal] = useState(false);
  const [isSimplepay, setIsSimplepay] = useState(false);
  const [checked_2, setChecked_2] = useState(false);
  const [checkedMarketing, setCheckedMarketing] = useState(false);
  const navigate = useNavigate();
  const firstnameRef = useRef();
  const emailRef = useRef();
  const passwordfirstRef = useRef();
  const passwordtwoRef = useRef();
  const nameRef = useRef();
  const addressRef = useRef();
  const postcodeRef = useRef();
  const cityRef = useRef();
  const countryRef = useRef();
  const buttonRef = useRef();
  const buttonRef_2 = useRef();
  const captchaRef = useRef()
  return <ProfileForm searchParams={searchParams} 
                      navigate={navigate} 
                      hideModal={props.hideModal} 
                      context={props.context} 
                      firstnameRef={firstnameRef}
                      emailRef={emailRef}
                      passwordfirstRef={passwordfirstRef}
                      passwordtwoRef={passwordtwoRef}
                      nameRef={nameRef}
                      addressRef={addressRef}
                      postcodeRef={postcodeRef}
                      cityRef={cityRef}
                      countryRef={countryRef}
                      buttonRef={buttonRef}
                      buttonRef_2={buttonRef_2}
                      hidePassword={hidePassword}
                      setHidePassword={setHidePassword}
                      hidePasswordtwo={hidePasswordtwo}
                      setHidePasswordtwo={setHidePasswordtwo}
                      checked={checked}
                      checked_2={checked_2}
                      checkedMarketing={checkedMarketing}
                      setChecked={setChecked}
                      setChecked_2={setChecked_2}
                      setCheckedMarketing={setCheckedMarketing}
                      captchaRef={captchaRef}
                      isPaypal={isPaypal}
                      setIsPaypal={setIsPaypal}
                      isSimplepay={isSimplepay}
                      setIsSimplepay={setIsSimplepay}
                      />;
}

export default ProfileFormFunc;
